import React, { useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import {
  Button,
  Card,
  Grid,
  Typography,
  CardActions,
  CardContent,
} from '@mui/material'
import { useFormikContext } from 'formik'
import { makeStyles } from '@mui/styles'
import MyButton from '../../../components/ui/MyButton'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import { useDropzone } from 'react-dropzone'
import { Cloudinary } from '@cloudinary/url-gen'

const useStyles = makeStyles((theme) => ({
  card: {
    // Provide some spacing between cards
    margin: 16,

    // Use flex layout with column direction for components in the card
    // (CardContent and CardActions)
    display: 'flex',
    flexDirection: 'column',

    // Justify the content so that CardContent will always be at the top of the card,
    // and CardActions will be at the bottom
    justifyContent: 'space-between',
  },
  paddingContainer: {
    padding: '0 4em',
  },
  linkText: {
    textTransform: 'uppercase',
    '&:hover, &:visited, &:active': {
      textTransform: 'uppercase',
      color: 'inherit',
    },
  },
  formControl: {
    marginBottom: '1em',
  },
  rowContainer: {
    padding: '0 7em',
  },
  degreeImageCard: {
    maxWidth: 300,
  },
  degreeImage: {
    width: '100%',
    height: 'auto',
  },
  expImageCard: {
    maxWidth: 200,
  },
  expImage: {
    width: '100%',
    height: 'auto',
  },
}))

const ExpImagesUploader = () => {
  const [dataToPreview, setDataToPreview] = useState([])

  const classes = useStyles()

  const { setFieldValue, values } = useFormikContext()

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'youspeak',
    },
  })

  let cldExpImages = []
  if (values && values.expImages && values.expImages.length > 0) {
    values.expImages.forEach(image => {
      const cldRes = cld.image(image)

      const cldExpImage = cldRes.toURL()

      cldExpImages.push(cldExpImage)
    })
  }

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          setDataToPreview((prevState) => prevState.concat(reader.result))
        }
      })

      setFieldValue(
        'selectedExpImages',
        values.selectedExpImages.concat(acceptedFiles)
      )
    },
    noClick: true,
    noKeyboard: true,
  })

  const deleteExpImages = (imageIndex) => {
    const filteredDataToPreview = dataToPreview.filter(
      (item, index) => index !== imageIndex
    )
    const filteredSelectedExpImages = values.selectedExpImages.filter(
      (item, index) => index !== imageIndex
    )
    setDataToPreview(filteredDataToPreview)

    setFieldValue('selectedExpImages', filteredSelectedExpImages)
  }

  const renderPreviewExpImages = (source) => {
    return source.map((photo, imageIndex) => {
      return (
        <Grid item className={classes.expImageCard} key={imageIndex}>
          <Card>
            <img src={photo} className={classes.expImage} alt="exp-images" />
            <CardActions>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => deleteExpImages(imageIndex)}
              >
                Remove
              </Button>
            </CardActions>
          </Card>
        </Grid>
      )
    })
  }

  return (
    <Card>
      <CardContent>
        <Grid container alignItems="center" direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h6">
              Upload your images of teaching experiences:{' '}
              <span style={{ color: 'red' }}>( * )</span>
            </Typography>
          </Grid>

          {values.expImages && values.expImages.length > 0 && (
            <Grid item>
              <Typography variant="body1">Your current files:</Typography>
            </Grid>
          )}

          <Grid item container justifyContent="center" alignItems="center" spacing={1}>
            {cldExpImages.length > 0 && cldExpImages.map((image, index) => (
              <Grid item className={classes.expImageCard} key={index}>
                <img
                  src={image}
                  className={classes.expImage}
                  alt="exp-images"
                />
              </Grid>
            ))}
          </Grid>

          <Grid item>
            <section>
              <div
                style={{
                  width: '100%',
                  border: '1px dashed lightgray',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '1em',
                }}
                {...getRootProps({ className: 'dropzone' })}
              >
                <input {...getInputProps()} />

                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <AddAPhotoIcon style={{ fontSize: '2rem' }} />
                  </Grid>

                  <Grid item>
                    <Typography variant="body2">
                      Drag 'n' drop some files here, or click to select files
                    </Typography>
                  </Grid>

                  <Grid item>
                    <MyButton onClick={open}>Select your files</MyButton>
                  </Grid>
                </Grid>
              </div>
            </section>
          </Grid>

          {dataToPreview.length > 0 && (
            <Grid item>
              <Typography variant="body1">Your selected files:</Typography>
            </Grid>
          )}
          <Grid item container justifyContent="center" alignItems="center" spacing={2}>
            {renderPreviewExpImages(dataToPreview)}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ExpImagesUploader
